import {UyapRequest} from "./UyapRequest";
import {MahkemeBirimleriRow} from "./CommonInterfaces";

export interface MahkemeBirimleriTalep {
    yargiTuru: number | string,
    yargiBirimi: number | string,
    dosyaKapaliMi: boolean | string
}

export interface MahkemeBirimleriCevap {
    items: Array<MahkemeBirimleriRow>
}

export class MahkemeBirimleri extends UyapRequest<MahkemeBirimleriTalep, MahkemeBirimleriCevap> {
    delayTime = 1000;

    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Mahkeme birimleri sorgulanıyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): any {
        return [
            {
                "birimAdi": "Alanya İcra Dairesi",
                "birimId": "1054058",
                "evraginBirimDVODaGonderilecegiBirimBilgisi": 0,
                "yeniBirimEkle": true,
                "orgKoduDegisti": false,
                "isTumunuKopyala": false,
                "eskiAd": "",
                "eskiOrgKod": "",
                "taranmamisKaydetme": "",
                "testMi": 0
            },
            {
                "birimAdi": "Ankara 1. Genel İcra Dairesi",
                "birimId": "1000967",
                "evraginBirimDVODaGonderilecegiBirimBilgisi": 0,
                "yeniBirimEkle": true,
                "orgKoduDegisti": false,
                "isTumunuKopyala": false,
                "eskiAd": "",
                "eskiOrgKod": "",
                "taranmamisKaydetme": "",
                "testMi": 0
            },
            {
                "birimAdi": "Ankara 2. Genel İcra Dairesi",
                "birimId": "1000963",
                "evraginBirimDVODaGonderilecegiBirimBilgisi": 0,
                "yeniBirimEkle": true,
                "orgKoduDegisti": false,
                "isTumunuKopyala": false,
                "eskiAd": "",
                "eskiOrgKod": "",
                "taranmamisKaydetme": "",
                "testMi": 0
            },
            {
                "birimAdi": "Ankara 4. Genel İcra Dairesi",
                "birimId": "1000954",
                "evraginBirimDVODaGonderilecegiBirimBilgisi": 0,
                "yeniBirimEkle": true,
                "orgKoduDegisti": false,
                "isTumunuKopyala": false,
                "eskiAd": "",
                "eskiOrgKod": "",
                "taranmamisKaydetme": "",
                "testMi": 0
            },
            {
                "birimAdi": "Ankara 5. Genel İcra Dairesi",
                "birimId": "1000950",
                "evraginBirimDVODaGonderilecegiBirimBilgisi": 0,
                "yeniBirimEkle": true,
                "orgKoduDegisti": false,
                "isTumunuKopyala": false,
                "eskiAd": "",
                "eskiOrgKod": "",
                "taranmamisKaydetme": "",
                "testMi": 0
            },
            {
                "birimAdi": "Ankara 6. Genel İcra Dairesi",
                "birimId": "1000946",
                "evraginBirimDVODaGonderilecegiBirimBilgisi": 0,
                "yeniBirimEkle": true,
                "orgKoduDegisti": false,
                "isTumunuKopyala": false,
                "eskiAd": "",
                "eskiOrgKod": "",
                "taranmamisKaydetme": "",
                "testMi": 0
            },
            {
                "birimAdi": "Ankara 7. Genel İcra Dairesi",
                "birimId": "1000942",
                "evraginBirimDVODaGonderilecegiBirimBilgisi": 0,
                "yeniBirimEkle": true,
                "orgKoduDegisti": false,
                "isTumunuKopyala": false,
                "eskiAd": "",
                "eskiOrgKod": "",
                "taranmamisKaydetme": "",
                "testMi": 0
            },
            {
                "birimAdi": "Ankara 8. Genel İcra Dairesi",
                "birimId": "1000939",
                "evraginBirimDVODaGonderilecegiBirimBilgisi": 0,
                "yeniBirimEkle": true,
                "orgKoduDegisti": false,
                "isTumunuKopyala": false,
                "eskiAd": "",
                "eskiOrgKod": "",
                "taranmamisKaydetme": "",
                "testMi": 0
            },
            {
                "birimAdi": "Bakırköy 2. İcra Dairesi",
                "birimId": "1001500",
                "evraginBirimDVODaGonderilecegiBirimBilgisi": 0,
                "yeniBirimEkle": true,
                "orgKoduDegisti": false,
                "isTumunuKopyala": false,
                "eskiAd": "",
                "eskiOrgKod": "",
                "taranmamisKaydetme": "",
                "testMi": 0
            },
            {
                "birimAdi": "Ankara Batı İcra Dairesi",
                "birimId": "1039299",
                "evraginBirimDVODaGonderilecegiBirimBilgisi": 0,
                "yeniBirimEkle": true,
                "orgKoduDegisti": false,
                "isTumunuKopyala": false,
                "eskiAd": "",
                "eskiOrgKod": "",
                "taranmamisKaydetme": "",
                "testMi": 0
            },
            {
                "birimAdi": "İstanbul Anadolu 20. İcra Dairesi",
                "birimId": "1030125",
                "evraginBirimDVODaGonderilecegiBirimBilgisi": 0,
                "yeniBirimEkle": true,
                "orgKoduDegisti": false,
                "isTumunuKopyala": false,
                "eskiAd": "",
                "eskiOrgKod": "",
                "taranmamisKaydetme": "",
                "testMi": 0
            }
        ];
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'avukat_mahkemeleri_sorgula.ajx';
    }

    async parse(data: Array<MahkemeBirimleriRow>): Promise<MahkemeBirimleriCevap> {
        return {
            items: data
        };
    }

}

export default MahkemeBirimleri;
